import { Route, Routes } from 'react-router-dom';
import { RestaurantPaymentProvidersPage } from '../pages';

export const RestaurantPaymentProvidersRoutes = () => {
  return (
    <Routes>
      <Route index element={<RestaurantPaymentProvidersPage />} />
    </Routes>
  );
};

export default RestaurantPaymentProvidersRoutes;
